import React, { useState } from "react";
import { parseExcel } from "./utils/ExcelParser";
import { generarMensaje } from "./utils/MessageFormatter";
import { abrirWhatsApp } from "./utils/WhatsAppSender";
import { Fila } from "./models/Fila";
import { ClipboardCopy, Send, Trash2, FileUp, Phone } from "lucide-react";

function App() {
  const [filas, setFilas] = useState([]);
  const [numero, setNumero] = useState("");
  const [emojiDict, setEmojiDict] = useState(null);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!emojiDict) {
      const dict = await fetch("/Frutas.json").then((res) => res.json());
      setEmojiDict(dict);

      parseExcel(file, (json) => {
        const nuevos = json.map((row) => new Fila(row, dict));
        setFilas(nuevos);
      });
    } else {
      parseExcel(file, (json) => {
        const nuevos = json.map((row) => new Fila(row, emojiDict));
        setFilas(nuevos);
      });
    }
  };

  const handleEnviar = () => {
    if (!filas.length || !numero.trim()) {
      alert("Faltan datos.");
      return;
    }

    const mensaje = generarMensaje(filas);
    navigator.clipboard.writeText(mensaje);

    const clean = numero.replace(/\D/g, "");
    const esNumeroValido = clean.length >= 10;

    if (esNumeroValido) {
      abrirWhatsApp(clean, mensaje);
    } else {
      window.open("https://web.whatsapp.com", "_blank");
      alert(`Mensaje copiado. Busca el grupo o contacto llamado "${numero}" y pégalo con Ctrl+V`);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img src="/logo.png" alt="Logo" style={styles.logo} />
        <h1 style={styles.title}>Difusión de Lista de Precios</h1>
      </div>

      <div style={{ ...styles.card, ...styles.row }}>
        <div style={styles.inputGroup}>
          <label style={styles.label}>
            <FileUp size={16} style={styles.icon} />
            Cargar archivo Excel
          </label>
          <input
            type="file"
            accept=".xlsx"
            onChange={handleFile}
            style={styles.inputFile}
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>
            <Phone size={16} style={styles.icon} />
            Número de contacto
          </label>
          <input
            type="text"
            placeholder="Ej: 3312345678"
            value={numero}
            onChange={(e) => setNumero(e.target.value)}
            style={styles.inputText}
          />
        </div>
      </div>

      <div style={styles.buttonRow}>
        <button
          onClick={() => {
            navigator.clipboard.writeText(generarMensaje(filas));
            alert("Mensaje copiado al portapapeles.");
          }}
          style={{ ...styles.button, ...styles.blue }}
        >
          <ClipboardCopy size={16} style={styles.icon} />
          Copiar mensaje
        </button>

        <button onClick={handleEnviar} style={{ ...styles.button, ...styles.green }}>
          <Send size={16} style={styles.icon} />
          Enviar por WhatsApp
        </button>

        <button
          onClick={() => {
            setNumero("");
            setFilas([]);
          }}
          style={{ ...styles.button, ...styles.tinto }}
        >
          <Trash2 size={16} style={styles.icon} />
          Limpiar formulario
        </button>
      </div>

      <div style={styles.preview}>
        <h3 style={styles.previewTitle}>Vista previa del mensaje</h3>
        <textarea
          rows={20}
          cols={100}
          value={generarMensaje(filas)}
          readOnly
          style={styles.textarea}
        />
      </div>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "Segoe UI, sans-serif",
    padding: "40px",
    maxWidth: "880px",
    margin: "30px auto",
    background: "#FAFAFA",
    borderRadius: "10px",
    border: "1px solid #E0E0E0",
  },
  icon: {
    marginRight: "8px",
    verticalAlign: "middle",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    marginBottom: "30px",
  },
  logo: {
    height: "70px",
    width: "auto",
    position: "absolute",
    left: 0,
  },
  title: {
    textAlign: "center",
    fontSize: "26px",
    fontWeight: "500",
    color: "#333333",
    margin: 0,
  },
  card: {
    marginBottom: "25px",
  },
  label: {
    fontWeight: "500",
    marginBottom: "6px",
    display: "block",
    fontSize: "15px",
    color: "#333",
  },
  inputFile: {
    fontSize: "15px",
    padding: "8px",
    border: "1px solid #D6D6D6",
    borderRadius: "6px",
    background: "#FFFFFF",
  },
  inputText: {
    width: "100%",
    padding: "10px",
    fontSize: "15px",
    borderRadius: "6px",
    border: "1px solid #D6D6D6",
    background: "#FFFFFF",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "25px",
    flexWrap: "wrap",
    gap: "15px",
  },
  button: {
    flex: "1",
    minWidth: "180px",
    padding: "10px 18px",
    fontSize: "15px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  blue: {
    backgroundColor: "#4B4B4B", // Gris elegante
    color: "#fff",
  },
  green: {
    backgroundColor: "#9A3324", // Tu color institucional
    color: "#fff",
  },
  tinto: {
    backgroundColor: "#EDEDED", // fondo claro para "limpiar"
    color: "#333",
    border: "1px solid #CCCCCC",
  },
  preview: {
    marginTop: "35px",
  },
  previewTitle: {
    fontSize: "17px",
    marginBottom: "8px",
    color: "#333",
  },

  textarea: {
    width: "100%",
    padding: "12px",
    fontSize: "14px",
    fontFamily: "monospace",
    borderRadius: "6px",
    border: "1px solid #D6D6D6",
    background: "#FFFFFF",
    resize: "vertical",
    color: "#333",
  },
  row: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap", // Esto permite que se acomode en columnas si el espacio es pequeño
  },

  inputGroup: {
    flex: "1",
    minWidth: "250px", // ancho mínimo para buena apariencia en pantallas pequeñas
  },
  };

export default App;
